import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './BusinessCardGenerator.css'
import QrPreview from './QrPreview'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const buildVCard = ({ name, role, phone, email, site }) =>
  [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${name}`,
    role ? `TITLE:${role}` : '',
    phone ? `TEL;TYPE=CELL:${phone}` : '',
    email ? `EMAIL:${email}` : '',
    site ? `URL:${site}` : '',
    'END:VCARD',
  ]
    .filter(Boolean)
    .join('\n')

const BusinessCardGenerator = () => {
  useDocumentMeta({
    title: 'Cartão de Visita Digital com QR Code  jarder.dev',
    description:
      'Crie um cartão de visita digital com QR Code (vCard) que salva ' +
      'seus contatos direto na agenda de quem escanear. Grátis.',
  })

  const [form, setForm] = useState({
    name: '',
    role: '',
    phone: '',
    email: '',
    site: '',
  })
  const [vCard, setVCard] = useState('')

  const updateField = (key, value) =>
    setForm((current) => ({ ...current, [key]: value }))

  const generate = () => {
    if (!form.name.trim()) return
    setVCard(buildVCard(form))
    trackEvent('tool_generate', { tool: 'business_card' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Cartão de Visita Digital</h1>
      <p className="tool-disclaimer">
        Gere um QR Code que, ao ser escaneado, salva seus dados direto na
        agenda de contatos de quem escanear (formato vCard).
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="name">Nome</label>
          <input
            id="name"
            type="text"
            value={form.name}
            onChange={(e) => updateField('name', e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="role">Cargo</label>
          <input
            id="role"
            type="text"
            value={form.role}
            onChange={(e) => updateField('role', e.target.value)}
          />
        </div>
      </div>
      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="phone">Telefone</label>
          <input
            id="phone"
            type="tel"
            value={form.phone}
            onChange={(e) => updateField('phone', e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="email">E-mail</label>
          <input
            id="email"
            type="email"
            value={form.email}
            onChange={(e) => updateField('email', e.target.value)}
          />
        </div>
      </div>
      <div className="tool-field">
        <label htmlFor="site">Site</label>
        <input
          id="site"
          type="text"
          value={form.site}
          onChange={(e) => updateField('site', e.target.value)}
        />
      </div>

      <button
        type="button"
        className="tool-button"
        onClick={generate}
        disabled={!form.name.trim()}
      >
        Gerar cartão
      </button>

      {vCard && (
        <div className="business-card">
          <p className="business-card-name">{form.name}</p>
          {form.role && <p className="business-card-role">{form.role}</p>}
          <QrPreview value={vCard} filename="cartao-de-visita.png" />
        </div>
      )}

      <div className="tool-info-section">
        <h2>O que é um cartão vCard</h2>
        <p>
          O QR Code gerado aqui contém um arquivo vCard  o formato
          padrão que celulares usam para importar contatos. Ao escanear
          com a câmera do celular, o nome, cargo, telefone, e-mail e site
          preenchidos aparecem prontos para salvar direto na agenda, sem
          digitar nada.
        </p>
        <p>
          É uma alternativa prática ao cartão de visita de papel: você
          pode exibir o QR Code na tela do celular, imprimir num crachá
          ou colocar na assinatura de e-mail.
        </p>
      </div>
    </div>
  )
}

export default BusinessCardGenerator
